import type { ElementType, HTMLAttributes } from 'react';
import { forwardRef } from 'react';
import styled from 'styled-components';

/**
 * A solid box with the body color scheme. Can be used to create panels on top of patterns or
 * have a section inverted from the main color scheme of the page: light -> dark / dark -> light
 *
 */
export const Panel = forwardRef<HTMLElement, IPanelProps>(
    ({ invert = false, branded = false, asElement, children, ...rest }, ref) => {
        return (
            <StyledPanel
                as={asElement}
                ref={ref}
                {...{
                    'data-cds-theme': invert ? 'dark' : undefined,
                    ...rest,
                }}
                $branded={branded}
            >
                {children}
            </StyledPanel>
        );
    }
);

export interface IPanelProps extends HTMLAttributes<HTMLElement> {
    /** Set the panel color to the inverted version of the whole page color scheme */
    invert?: boolean;
    branded?: boolean;
    asElement?: ElementType;
}

const StyledPanel = styled.div<{ $branded: boolean }>`
    background-color: ${({ $branded }) =>
        $branded ? 'var(--color-body-accentStripe)' : 'var(--cds-color-background)'};
    color: var(--cds-color-text);
`;
